import { render, staticRenderFns } from "./form-login.vue?vue&type=template&id=3923d022&scoped=true&"
import script from "./form-login.ts?vue&type=script&lang=ts&"
export * from "./form-login.ts?vue&type=script&lang=ts&"
import style0 from "./form-login.scss?vue&type=style&index=0&id=3923d022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3923d022",
  null
  
)

export default component.exports